module.exports = __webpack_public_path__ + "static/media/advantage-2.cfde43a5.svg";